import CardProject from '../../components/items/CardProject'

import tripAdventure from '../../img/projects/tripAdventure.png'
import react from '../../img/technology/react.png'
import html from '../../img/technology/html.png'
import css from '../../img/technology/css.png'
import javaScript from '../../img/technology/javascript.png'

export default function Project3() {
  return (
    <div>
      <CardProject
        name="TripAdventure"
        img={tripAdventure}
        text="O projeto TripAdventure é um layout de site que se concentra em oferecer uma experiência envolvente e informativa sobre viagens. Desenvolvido em ReactJS, o site apresenta uma navegação fluida e responsiva, facilitada pelo React Router. Além disso, para enriquecer a experiência do usuário, utiliza animações suaves e interativas fornecidas pela biblioteca Framer Motion. A inclusão da biblioteca React Scroll permite uma rolagem suave e intuitiva em toda a página, aprimorando a acessibilidade e a usabilidade do site. Com ícones visualmente atrativos provenientes da biblioteca React Icons, o projeto visa transmitir uma sensação de aventura e descoberta aos visitantes do site. Por meio deste projeto, o objetivo é inspirar e informar os usuários sobre destinos de viagem emocionantes e experiências memoráveis ao redor do mundo."
        app="https://trip-adventure.vercel.app/"
        repo="https://github.com/RiccettoDev/tripAdventure"
        technology1={react}
        nameTechnology1="React JS"
        technology2={html}
        nameTechnology2="HTML"
        technology3={css}
        nameTechnology3="CSS"
        technology4={javaScript}
        nameTechnology4="JavaScript"
      />
    </div>
  )
}
